var map = {
	"./mirandaenvios/stories.json": 1199,
	"./ria/stories.json": 554,
	"./viva/stories.json": 1200,
	"./walmart/stories.json": 1201
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1198;


//////////////////
// WEBPACK FOOTER
// ./src/assets/prismicDoc ^\.\/.*\/stories\.json$
// module id = 1198
// module chunks = 245